import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { useAppSelector } from '@/store/hooks'
import { Link } from 'react-router-dom'
import { Navigate, useLocation } from 'react-router-dom'
interface AuthProps {
	children: React.ReactNode
}

export function AuthLayout({ children }: AuthProps) {
	const {
		auth: { signed },
	} = useAppSelector((state) => state)

	const location = useLocation()

	if (signed) {
		return <Navigate to='/' state={{ redirect: location.pathname }} />
	}

	return (
		<div className='flex flex-col min-h-screen bg-bgbase dark:bg-[#150E1D] items-center justify-center'>
			<div
				className='absolute w-full h-screen bg-no-repeat bg-left-top block z-0'
				style={{ backgroundImage: "url('/imgs/auth/login/lines.png')" }}
			/>
			<div
				className='absolute w-full h-screen bg-no-repeat bg-right-bottom bg-contain hidden lg:block'
				style={{ backgroundImage: "url('/imgs/auth/login/bg.png')" }}
			/>
			<Container className='px-4 xl:px-6 xl:pl-28 z-10'>
				<div className='w-full mb-28 gap-28 md:max-w-[480px] lg:max-w-[440px] flex flex-col justify-center'>
					<Link to='/' className='cursor-pointer'>
						<Icon
							name='logo'
							width='150'
							height='55'
							className='w-[150px] h-auto text-[#150e1d] dark:text-white'
						/>
					</Link>
					{children}
				</div>
			</Container>

			{/* BUTTON DARKMODE */}
			{/* <div className='fixed right-4 bottom-8'>
				<ToogleDark />
			</div> */}
		</div>
	)
}
